import {
    ApiHandlerNoApiParameter,
    createHandlerChainRunner,
    executeAwaitableHandlerChain,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { getBrandById, GetBrandByIdApiParameter, getBrandByPath } from "@insite/client-framework/Services/BrandService";
import { CatalogPage } from "@insite/client-framework/Services/CategoryService";
import { getCatalogPageStateByPath } from "@insite/client-framework/Store/Data/CatalogPages/CatalogPagesSelectors";
import loadCatalogPageByPath from "@insite/client-framework/Store/Data/CatalogPages/Handlers/LoadCatalogPageByPath";
import { BrandModel } from "@insite/client-framework/Types/ApiModels";

export interface LoadBrandByIdParameter {
    path: string;
}
interface Props {
    catalogPage: CatalogPage;
}
type HandlerType = ApiHandlerNoApiParameter<LoadBrandByIdParameter & HasOnSuccess<BrandModel>, BrandModel, Props>;

export const RequestCatalogPageFromApi: HandlerType = async props => {
    const { path } = props.parameter;
    if (path) {
        props.catalogPage = getCatalogPageStateByPath(props.getState(), path).value as CatalogPage;
        if (props.catalogPage) {
            return;
        }
        props.catalogPage = await executeAwaitableHandlerChain(loadCatalogPageByPath, { path }, props);
    }
};

export const DispatchBeginLoadBrand: HandlerType = props => {
    const brandId = props?.catalogPage?.brandId as string;
    if (brandId) {
        props.dispatch({
            type: "Data/Brands/BeginLoadBrand",
            id: brandId,
        });
    }
};

export const RequestDataFromApi: HandlerType = async props => {
    const brandId = props?.catalogPage?.brandId as string;
    if (brandId) {
        const brandParam = {
            brandId,
        } as GetBrandByIdApiParameter;
        const brand = await getBrandById(brandParam);
        props.apiResult = brand;
    }
};

export const LoadBrandDescription: HandlerType = async props => {
    try {
        if (props.apiResult) {
            const brandData = await getBrandByPath(props.parameter);
            props.apiResult.htmlContent = brandData?.htmlContent;
        }
    } catch (error) {
        if (error?.status === 404) {
            return;
        }
        throw error;
    }
};

export const DispatchCompleteLoadBrand: HandlerType = props => {
    const brandId = props?.catalogPage?.brandId as string;
    if (brandId) {
        props.dispatch({
            type: "Data/Brands/CompleteLoadBrand",
            id: brandId,
            brand: props.apiResult,
        });
    }
};
export const ExecuteOnSuccessCallback: HandlerType = props => {
    const brandId = props?.catalogPage?.brandId as string;
    if (brandId) {
        markSkipOnCompleteIfOnSuccessIsSet(props);
        props.parameter.onSuccess?.(props.apiResult);
    }
};

export const chain = [
    RequestCatalogPageFromApi,
    DispatchBeginLoadBrand,
    RequestDataFromApi,
    LoadBrandDescription,
    DispatchCompleteLoadBrand,
    ExecuteOnSuccessCallback,
];

const productListBrandDetailsHandler = createHandlerChainRunner(chain, "ProductListBrandDetailsHandler");
export default productListBrandDetailsHandler;
